/* 
Self Contained Livepeer Staker
Interacts directly with Livepeers BondingManager, LivepeerToken and RoundsManager smart contracts using Metamask
Requires a parent component to hold and pass the exported variables from hooks/WithLivepeer.js
*/
import { Stack, Text, Group, Flex } from "@mantine/core";
import MetaMask from "./components/MetaMaskButton";
import "./styles.css";
import StakeViewSelector from "./StakeViewSelector";
import { useState, useEffect } from "react";
import ProgressBar from "./components/ProgressBar";
import web3 from "web3";

export default function LivepeerStaker(props) {
  const [inputValue, setInput] = useState(0);
  const [isErr, setErr] = useState(false);
  const [orchestratorAddr, setOrchestrator] = useState(process.env.REACT_APP_POOL_ORCHESTRATOR_ADDRESS);
  // On render, always do a refresh of the connected wallet and Livepeer data
  useEffect(() => {
    props.checkIfWalletIsConnected();
    props.refreshWallet();
  }, []);
  // In case of error, we want to notify the user they can go here to use the official explorer to stake to us
  const routeChange = () => {
    window.open("https://explorer.livepeer.org/accounts/" + orchestratorAddr + "/orchestrating", '_blank', 'noreferrer');
  };
  // Display a view containing the title, Metamask button and progress bar wrapped around the StakeViewSelector,
  // which displays current actions the connected wallet can do
  return (
    <Stack spacing={24} justify="center" style={{ height: "100%" }}>
      <Group position="apart" spacing="28px" grow>
        <Text size="xl" fw={700}>
          Stake Now
        </Text>
        <MetaMask
          connectWallet={props.connectWallet}
          connectedWallet={props.connectedWallet}
        />
      </Group>
      <Flex
        mih={50}
        gap="md"
        justify="center"
        align="flex-start"
        direction="row"
        wrap="wrap"
        style={{ height: "100%" }}
      >
        <StakeViewSelector
          getHints={props.getHints}
          transcoderTable={props.transcoderTable}
          inputValue={inputValue}
          setInput={setInput}
          setErr={setErr}
          connectedWallet={props.connectedWallet}
          allowance={props.allowance}
          bondedWith={props.bondedWith}
          bondedLPT={props.bondedLPT}
          thisRound={props.currentRound}
          ETHbalance={props.ETHbalance}
          LPTbalance={props.LPTbalance}
          orchestratorAddr={orchestratorAddr}
          setOrchestrator={setOrchestrator}
          refreshWallet={props.refreshWallet}
          delegatorState={props.delegatorState}
          locks={props.locks}
          pendingEth={props.pendingEth}
          isSyncing={props.isSyncing}
          cachedENS={props.cachedENS}
        />
      </Flex>
      {isErr ? (
        <Flex
          mih={50}
          gap="md"
          justify="center"
          align="flex-start"
          direction="row"
          wrap="wrap"
        >
          <Text size="xl" fw={700} onClick={routeChange} className="textLink">
            If things aren't working as expected, click here to use the official
            Livepeer explorer to manage your stake
          </Text>
        </Flex>
      ) : null}
      {props.connectedWallet != "" ? (
        <Text>
          Balance:{" "}
          {parseFloat(
            web3.utils.fromWei(props.ETHbalance.toString(), "ether") || 0
          ).toFixed(4)}{" "}
          Eth and{" "}
          {parseFloat(
            web3.utils.fromWei(props.LPTbalance.toString(), "ether") || 0
          ).toFixed(2)}{" "}
          LPT
        </Text>
      ) : null}
      <ProgressBar
        thisProgress={props.thisProgress}
        isErr={props.isTranscoderTableErr}
      />
    </Stack>
  );
}
